import React, { useState, useEffect } from "react";
import { Link } from 'react-router-dom'
import carrefour from "../../../../images/client-logo/ing.jpg";
import mg from "../../../../images/client-logo/mg.webp";
import baraka from "../../../../images/client-logo/baraka.webp";
import green from "../../../../images/client-logo/green.webp";
import lbp from "../../../../images/client-logo/lbp.webp";
import horizon from "../../../../images/client-logo/horizon.webp";
import cbf from "../../../../images/client-logo/CBF.webp";
import oasis from "../../../../images/client-logo/oasis.webp";
import nour from "../../../../images/client-logo/nour.webp";
import sages from "../../../../images/client-logo/sages.webp";
import saft from "../../../../images/client-logo/saft.webp";
import golf from "../../../../images/client-logo/golf.webp";
import agri from "../../../../images/client-logo/agri-products.webp";
import slim from "../../../../images/client-logo/slim.webp";


import { useTranslation } from "react-i18next";
import Aos from "aos";

const images = [
  {
    id: 3,
    name: "Grande Surface",
    agriculture: true,
    imgUrl: carrefour
  },
  {
    id: 4,
    name: "Grande Surface",
    chemical: true,
    imgUrl: mg
  },
  {
    id: 7,
    name: "Dattes",
    agriculture: true,
    imgUrl: baraka
  },
  {
    id: 8,
    name: "Grand Distribution",
    agriculture: true,
    imgUrl: green
  },
  {
    id: 9,
    name: "Grand Distribution",
    agriculture: true,
    imgUrl: lbp
  },
  {
    id: 10,
    name: "Grand Distribution",
    agriculture: true,
    imgUrl: horizon
  },
  {
    id: 11,
    name: "Dattes",
    agriculture: true,
    imgUrl:  cbf 
  }, 
  {
    id: 12,
    name: "Dattes",
    agriculture: true,
    imgUrl:  oasis 
  },
  {
    id: 13,
    name: "Dattes",
    agriculture: true,
    imgUrl:  nour 
  },
  {
    id: 14,
    name: "Dattes",
    agriculture: true,
    imgUrl:  sages 
  },   
  {
    id: 15,
    name: "Dattes",
    agriculture: true,
    imgUrl:  saft 
  },   
  {
    id: 16,
    name: "Dattes",
    agriculture: true,
    imgUrl:  golf 
  },   
  {
    id: 17,
    name: "Dattes",
    agriculture: true,
    imgUrl:  agri 
  },   
  {
    id: 18,
    name: "Dattes",
    agriculture: true,
    imgUrl:  slim 
  },   
];


const getFilterSections = (images) => {
  const filters = ['Tout']
  images.map(image => {
    if (filters.indexOf(image.name) === -1) {
      filters.push(image.name)
    }
  })
  return filters
}

const filterImages = (filterKey, images) => {
  const list = images.filter(image =>
    filterKey === 'Tout' ? image : image.name === filterKey
  );

  return list
}

const Portfolio = props => {
  const [state, setState] = useState({
    list: images,
    filterKey: "Tout"
  });

  const { list, filterKey } = state;

  const filteredList = filterImages(filterKey, list)
  const filters = getFilterSections(images)
  const collumnCls = props.col ? props.col : "col-md-3";

  const [t, i18n] = useTranslation('traduction');

  useEffect(() => {
    Aos.init({
      duration: 1500,
      disable: 'mobile',
      once: true,
      mirror: false
    });
    i18n.changeLanguage(props.lang);
  }, [i18n, props.lang]);

  return (
    <div class="content-block">
      <div class="section-full content-inner-2 portfolio text-uppercase bg-gray" id="portfolio">
        <div class="container">
          <div class="site-filters clearfix center  m-b40">
            {/* FILTERS */}
            <ul class="filters" data-toggle="buttons">
              {filters.map(filter => (
                <li class="btn" onClick={() => setState({ ...state, filterKey: filter })}>
                  <div className="site-button-secondry button-sm radius-xl">
                    <span>{t(filter)}</span>
                  </div>
                </li >
              ))}
            </ul>
          </div>

          {/* FILTERED PORTFOLIO LIST */}
          <div className="portfolio_area">
            <div className="row portfolio-grid">
              {filteredList.map(image => (
                <div className={collumnCls}>
                  <div class="dlab-box dlab-gallery-box" data-aos="zoom-in">
                    {/* <div class="dlab-media dlab-img-overlay1 dlab-img-effect References-images" style={{ height: "250px" }}> */}
                    {/* <Link to="/portfolio-details"> <img src={image.imgUrl} alt="" /> </Link> */}
                    <div class="dlab-media dlab-img-overlay12 left" style={{ height: "250px" }}>
                      <img src={image.imgUrl} alt="0" />
                      <div class="dlab-info-has p-a20  ">
                        <div class="dlab-post-title">
                          <h5 class="post-title">{t(image.name)} </h5>
                        </div>
                      </div>
                    </div>
                    {/* </div> */}
                  </div>




                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>


  );
};

export default Portfolio;
